import React, { useState, useEffect } from 'react';

const NewsletterSection = ({
                               title,
                               description,
                               placeholder,
                               buttonText,
                               privacyText,
                               additionalClassName = '',
                           }) => {
    const [email, setEmail] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            email,
            list_uuids: ["47659efa-336b-4bf4-b644-81a855426103"]
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        try {
            const response = await fetch("https://listmonk.cloudtal.de/api/public/subscription", requestOptions);

            if (response.ok) {
                const result = await response.json();

                // Prüfen, ob die Antwort besagt, dass die E-Mail bereits eingetragen ist
                if (result?.data?.has_optin === false) {
                    setErrorMessage("This email is already subscribed.");
                    setSuccessMessage("");
                } else {
                    setSuccessMessage("You have successfully subscribed to the newsletter!");
                    setErrorMessage("");
                }
            } else {
                const result = await response.text();
                setErrorMessage(result || "An error occurred.");
                setSuccessMessage("");
            }
        } catch (error) {
            setErrorMessage("An error occurred while subscribing.");
            setSuccessMessage("");
        }
    };

    useEffect(() => {
        const successToast = document.getElementById('successToast');
        const errorToast = document.getElementById('errorToast');

        if (successMessage) {
            successToast.classList.remove('opacity-0', 'translate-y-4');
            successToast.classList.add('opacity-100', 'translate-y-0');

            setTimeout(() => {
                fadeOutToast('successToast');
            }, 5000);
        }

        if (errorMessage) {
            errorToast.classList.remove('opacity-0', 'translate-y-4');
            errorToast.classList.add('opacity-100', 'translate-y-0');

            setTimeout(() => {
                fadeOutToast('errorToast');
            }, 8000);
        }
    }, [successMessage, errorMessage]);

    const closeToast = (id) => {
        fadeOutToast(id);
    };

    const fadeOutToast = (id) => {
        const toast = document.getElementById(id);
        if (toast) {
            toast.classList.remove('opacity-100', 'translate-y-0');
            toast.classList.add('opacity-0', 'translate-y-4');

            toast.addEventListener('transitionend', () => {
                toast.remove();
            });
        }
    };

    return (
        <section
            id="newsletter"
            className={`w-full py-12 md:py-24 lg:py-32 ${additionalClassName}`}
        >
            <div id="toast-container" className="fixed top-5 right-1/2 transform translate-x-1/2 z-50 flex flex-col space-y-2">
                {/* Success Toast */}
                <div
                    id="successToast"
                    className={`max-w-sm w-full bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded shadow-md flex items-center justify-between opacity-0 transform translate-y-4 transition-all duration-500 ${
                        successMessage ? '' : 'hidden'
                    }`}
                    role="alert"
                >
                    <span>{successMessage}</span>
                    <button onClick={() => closeToast('successToast')} className="text-green-700 hover:text-green-900 focus:outline-none">
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Error Toast */}
                <div
                    id="errorToast"
                    className={`max-w-sm w-full bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded shadow-md flex items-center justify-between opacity-0 transform translate-y-4 transition-all duration-500 ${
                        errorMessage ? '' : 'hidden'
                    }`}
                    role="alert"
                >
                    <div>
                        <p>{errorMessage}</p>
                    </div>
                    <button onClick={() => closeToast('errorToast')} className="text-red-700 hover:text-red-900 focus:outline-none">
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>

            <div className="container px-4 md:px-6">
                <div className="flex flex-col items-center justify-center space-y-4 text-center">
                    <div className="space-y-2">
                        <h2 className="text-3xl font-bold sm:text-5xl">
                            {title}
                        </h2>
                        <p className="max-w-[900px] text-zinc-300 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed :text-zinc-400">
                            {description}
                        </p>
                    </div>
                    <div className="w-full max-w-sm space-y-2">
                        <form className="flex space-x-2" onSubmit={handleSubmit}>
                            <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="flex h-10 w-full rounded-md border border-input bg-background !text-black px-3 py-2 text-base placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm flex-1"
                                placeholder={placeholder}
                                required
                            />
                            <button
                                className="bg-zinc-800 text-zinc-200 px-6 rounded font-medium transition-transform duration-300 hover:scale-105"
                                type="submit"
                            >
                                {buttonText}
                            </button>
                        </form>
                        <p className="text-xs text-zinc-500 :text-zinc-400">
                            {privacyText}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewsletterSection;